
    import Vue from 'vue';
    import Scroll  from 'components/plugin/scroll'
    import encrypt from 'components/plugin/lib/encrypt.js'
    import AvatarCropper from "vue-avatar-cropper"
    import animate from 'animate.css'

    Vue.filter('amount_convert',function(val){
        return (val/100).toFixed(2)
    })

    export default {
        components: {
            Scroll,
            AvatarCropper
        },
        data () {
            return {
                loading: 1,
                bottom: 0,
                apiData: {
                    keyword: '',
                    pageNum: 20,
                    circleId: '',
                },
                data: null,
                marketPageQueryVO: [],
            }
        },
        beforeRouteEnter (to, from, next) {
            next(vm => {
                //当用户不存在或ddtoken不存在时return
                if(!to.query.circleId) return;
                vm.apiData = to.query;
                vm.getShopList();
            })
        },
        mounted () {
        
            // this.getShopList();
        },
        methods: {

            // 搜索商家
            getShopList (type) {
                this.loading = 1;
                this.$http.get('/circle2/v2/shop/searchByCircle', {
                    params: encrypt(this.apiData)
                }).then(res => {
                    this.data = res.body.data;
                    var marketPageQueryVO = res.body.data.marketPageQueryVO.marketListVOS;
                    if (marketPageQueryVO.length > 0) {
                        if (type == 'add' && this.marketPageQueryVO.length > 0) {
                            this.marketPageQueryVO = [...this.marketPageQueryVO,...marketPageQueryVO];
                        } else {
                            this.marketPageQueryVO = marketPageQueryVO;
                        }

                        if (marketPageQueryVO.length >= 20) {
                            this.lastRowId = changeList[changeList.length - 1].rowId
                        } else {
                            this.bottom = 1;
                        }

                        this.loading = 0;
                        return
                    } else {
                        this.loading = 0;
                        this.bottom = 1;
                        return
                    }


                })
            },
            onBottom () {
                //第一页都不够的话，直接不去加载
                if(this.marketPageQueryVO.length < 20 || this.bottom){
                    this.bottom = 1;
                    return
                }
                
                if(!this.loading){
                    this.getShopList('add');
                }
            },
            // 选择结果
            selectShop (shopId, shopName, isEcomShop) {
                var data = {
                    relationId: shopId,
                    relationName: shopName,
                    relationType: isEcomShop
                };
                sessionStorage.setItem('relationData', '');
                sessionStorage.setItem('relationData', JSON.stringify(data));
                this.goSceneCreate();
            },
            // 返回创建现场页面
            goSceneCreate(){
                this.$router.push({name:'sceneCreate'})
            },
            // 返回搜索列表页面
            goSearchPage () {
                var queryData = {
                    keyword: this.apiData.keyword,
                    userId: this.apiData.userId,
                    circleId: this.apiData.circleId,
                };
                this.$router.push({
                    name: 'ShopSearch',
                    query: queryData
                })
            }


        }

    }


// WEBPACK FOOTER //
// ./src/components/page/scene/searchList/list.js